import { render, staticRenderFns } from "./salary-set.vue?vue&type=template&id=0a5bb600&scoped=true"
import script from "./salary-set.vue?vue&type=script&lang=js"
export * from "./salary-set.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5bb600",
  null
  
)

export default component.exports